import React from 'react'
import { observer } from 'mobx-react-lite'
import { ScheduleDelay } from 'shared/ui/Schedule/ui/ScheduleDelay'
import { type IDropdownItem, SwitchField, Typography } from 'shared/ui'
import { type CustomField } from 'entities/CustomField'
import { DateFieldDropdown } from 'pages/campaigns/ui/CampaignSchedule/ui/ScheduleDateFiled/ui/DateFieldDropdown/DateFieldDropdown'
import { WhenDropdown } from 'pages/campaigns/ui/CampaignSchedule/ui/ScheduleDateFiled/ui/WhenDropdown/WhenDropdown'
import { DateFiledSettings } from 'pages/campaigns/ui/CampaignSchedule/ui/ScheduleDateFiled/ui/DateFiledSettings/DateFiledSettings'
import { useScheduleDateFiledContext } from '../context/sendLaterContext'
import styles from './styles.module.scss'

export type IScheduleDateFiledUIProps = {
  dropdownId: string
}

export const ScheduleDateFiledUI = observer(({ dropdownId }: IScheduleDateFiledUIProps) => {
  const {
    scheduleDelayStore,
    dateFieldDropdownStore,
    dateFiledType,
    isUseContactTimezone,
    isUseTimeFromField,
    when,
    toggleUseContactTimezone,
    isMinutesOrHoursPeriod,
    isNoMinutesAndHoursPeriods,
  } = useScheduleDateFiledContext()

  const getDropdownItemProps = (field: CustomField): Partial<IDropdownItem> => {
    if (field.type === 'date' && isMinutesOrHoursPeriod) {
      return {
        disabled: true,
        tooltipProps: {
          label: (
            <div className={styles.wrapDisabledDateTooltip}>
              <Typography
                ariaLabel={'tooltip'}
                variant={'body-md-regular'}
                color={'var(--content-primary-primary-inverted)'}
              >
                Date field can be used only with these delays:
              </Typography>
              <Typography
                ariaLabel={'tooltip'}
                variant={'body-sm-regular'}
                color={'var(--content-primary-tertiary-inverted)'}
              >
                Days, Weeks, Months
              </Typography>
            </div>
          ),
          placement: 'right',
        },
      }
    }
    return {}
  }

  return (
    <>
      <div className={styles.content}>
        {when !== 'on' && (
          <ScheduleDelay
            store={scheduleDelayStore}
            dropdownId={dropdownId}
            excludePeriods={isNoMinutesAndHoursPeriods ? ['minutes', 'hours'] : []}
          />
        )}
        <WhenDropdown dropdownId={dropdownId} />
        <DateFieldDropdown
          dropdownId={dropdownId}
          store={dateFieldDropdownStore}
          getDropdownItemProps={getDropdownItemProps}
        />
        {dateFiledType && <DateFiledSettings dropdownId={dropdownId} />}
      </div>

      {(dateFiledType === 'date' || (dateFiledType === 'datetime' && !isUseTimeFromField)) && (
        <div className={styles.content}>
          <SwitchField
            value={!!isUseContactTimezone}
            onClick={toggleUseContactTimezone}
            labelProps={{
              label: {
                leftIcon: 'userFilled',
                text: 'Use contact timezone',
              },
              questionTooltipProps: {
                label:
                  "Sends messages based on the contact's time zone, determined by their phone number's area code.",
                width: 240,
                breakWord: true,
              },
            }}
          />
        </div>
      )}
    </>
  )
})
